// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__31oYu","arabic_wrapper":"styles_arabic_wrapper__ptUjx","button":"styles_button__I9hvv","buttonDisabled":"styles_buttonDisabled__jqGgF"};